export const URL_ME = "/auth/me";
export const URL_LOGIN = "/auth/login";
